const english = {
  nav: { assessment: "Assessment", blog: "Blog" },
  common: {
    genericError: "Something went wrong. Please try again.",
    readMore: "Read more",
    readLess: "Read less"
  },
  newsletter: {
    heading: "Stay Healthy with Our Nutrition Tips!",
    intro: "Subscribe to receive monthly emails with nutrition tips, delicious recipes, and insightful blog posts. Don’t worry, we respect your inbox you’ll only get one or two emails a month, and you can unsubscribe anytime.",
    firstName: "First name",
    lastName: "Last name",
    email: "Email",
    emailAddress: "Email address",
    consentHeading: "Email subscription preference",
    consentTitle: "Stay Healthy with Our Nutrition Tips!",
    consentDescription: "Subscribe to receive monthly emails with nutrition tips, delicious recipes, and insightful blog posts. Don’t worry, we respect your inbox you’ll only get one or two emails a month, and you can unsubscribe anytime.",
    consent: "Stay Healthy with Our Nutrition Tips! Subscribe to receive monthly emails with nutrition tips, delicious recipes, and insightful blog posts. Don’t worry, we respect your inbox you’ll only get one or two emails a month, and you can unsubscribe anytime.",
    noConsent: "No, I don't want to receive these emails.",
    signupButton: "Yes, I do want to receive these communications",
    detailsError: "Please enter your first name, last name and a valid email address.",
    consentError: "Please tick the consent box before subscribing.",
    noConsentSuccess: "No problem. You have not been subscribed.",
    emailError: "Please enter a valid email address.",
    success: "Thanks for subscribing. You have been added to the newsletter list.",
    shortSuccess: "Thanks for subscribing.",
    saving: "Saving...",
    subscribing: "Subscribing...",
    subscribe: "Subscribe",
    footerHeading: "Stay Healthy with Our Nutrition Tips!",
    footerIntro: "Subscribe to receive monthly emails with nutrition tips, delicious recipes, insightful blog posts and special offers. Don’t worry, we respect your inbox you’ll only get one or two emails a month, and you can unsubscribe anytime."
  },
  blog: {
    eyebrow: "Nutrition by Iballa Blogs",
    heading: "Evidence-based nutrition guidance",
    intro: "Practical, supportive articles to help you understand your health and build sustainable nutrition habits.",
    latest: "Latest Blog",
    allPosts: "All Posts",
    readMore: "Read More",
    back: "Back to Blog",
    references: "References",
    previous: "Previous Article",
    next: "Next Article",
    notFound: "Article not found",
    notFoundText: "The article you are looking for is not available."
  },
  assessment: {
    title: "Nutrition Assessment",
    intro: "Get a general overview of your everyday nutrition habits and simple ideas to support your goals.",
    beforeTitle: "Before you start",
    beforeIntro: "Add your details to begin your personalised nutrition overview.",
    firstName: "First name",
    lastName: "Last name",
    email: "Email",
    consentHeading: "Email subscription preference",
    consentTitle: "Stay Healthy with Our Nutrition Tips!",
    consentDescription: "Subscribe to receive monthly emails with nutrition tips, delicious recipes, and insightful blog posts. Don’t worry, we respect your inbox you’ll only get one or two emails a month, and you can unsubscribe anytime.",
    consent: "Stay Healthy with Our Nutrition Tips! Subscribe to receive monthly emails with nutrition tips, delicious recipes, and insightful blog posts. Don’t worry, we respect your inbox you’ll only get one or two emails a month, and you can unsubscribe anytime.",
    noConsent: "No, I don't want to receive these emails.",
    signupButton: "Yes, I do want to receive these communications",
    detailsError: "Please enter your first name, last name and a valid email address.",
    saving: "Saving...",
    start: "Start assessment",
    complete: "Assessment complete",
    step: (current, total) => `Step ${current} of ${total}`,
    contactDetails: "Contact details",
    disclaimer: "This tool provides general educational insights only. It does not diagnose or replace personalised medical or dietetic advice.",
    percentComplete: (value) => `${value}% complete`,
    back: "Back",
    viewResults: "View Results",
    next: "Next",
    summary: "Your general summary",
    outOf: "out of 100",
    positiveFocus: "You're doing well with",
    improvementFocus: "Areas to focus on next",
    noPositiveFocus: "Your answers give us a clear starting point. As you build consistency, stronger positive areas will become easier to highlight.",
    recommendations: "Practical recommendations",
    tailoredHeading: "Looking for tailored nutrition guidance?",
    tailoredText: "While this assessment provides general nutrition insights, a consultation can provide personalised recommendations based on your goals, lifestyle, and health history.",
    book: "BOOK A CONSULTATION",
    backAnswers: "Back to answers",
    restart: "Restart assessment"
  },
  admin: {
    eyebrow: "Admin",
    heading: "Newsletter Subscribers",
    intro: "Review subscriber consent, signup source and unsubscribe status.",
    notConfigured: "Supabase is not configured",
    notConfiguredText: "Add REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_PUBLISHABLE_KEY to .env.local to enable admin login.",
    checking: "Checking session...",
    signIn: "Admin sign in",
    signInHelp: "Use your Supabase Auth admin account.",
    email: "Email",
    password: "Password",
    signInButton: "Sign in",
    accessRequired: "Admin access required",
    accessText: "You are signed in, but this account is not listed in the admin_users table.",
    signOut: "Sign out",
    signedIn: "Signed in as admin",
    columns: ["Name", "Email", "Source", "Consent", "Signup date", "Unsubscribe status", "MailerLite sync", "Action"],
    loading: "Loading subscribers...",
    empty: "No subscribers yet.",
    consented: "Consented",
    noConsent: "No consent",
    unsubscribed: "Unsubscribed",
    subscribed: "Subscribed",
    markSubscribed: "Mark subscribed",
    markUnsubscribed: "Mark unsubscribed",
    sources: { blog: "Blog", homepage: "Homepage", assessment: "Assessment" },
    providerStatuses: {
      synced: "Synced",
      pending: "Pending",
      failed: "Failed",
      skipped: "Skipped",
      not_configured: "Not configured"
    }
  }
};

const spanish = {
  nav: { assessment: "Evaluación", blog: "Blog" },
  common: {
    genericError: "Ha ocurrido un error. Inténtalo de nuevo.",
    readMore: "Leer más",
    readLess: "Leer menos"
  },
  newsletter: {
    heading: "Mantente saludable con nuestros consejos de nutrición",
    intro: "Suscríbete para recibir correos mensuales con consejos de nutrición, recetas deliciosas y artículos del blog. No te preocupes, respetamos tu bandeja de entrada: solo recibirás uno o dos correos al mes y puedes darte de baja cuando quieras.",
    firstName: "Nombre",
    lastName: "Apellidos",
    email: "Correo electrónico",
    emailAddress: "Correo electrónico",
    consentHeading: "Preferencia de suscripción por correo electrónico",
    consentTitle: "Mantente saludable con nuestros consejos de nutrición",
    consentDescription: "Suscríbete para recibir correos mensuales con consejos de nutrición, recetas deliciosas y artículos del blog. No te preocupes, respetamos tu bandeja de entrada: solo recibirás uno o dos correos al mes y puedes darte de baja cuando quieras.",
    consent: "Mantente saludable con nuestros consejos de nutrición. Suscríbete para recibir correos mensuales con consejos de nutrición, recetas deliciosas y artículos del blog. No te preocupes, respetamos tu bandeja de entrada: solo recibirás uno o dos correos al mes y puedes darte de baja cuando quieras.",
    noConsent: "No, no quiero recibir estos correos.",
    signupButton: "Sí, quiero recibir estas comunicaciones",
    detailsError: "Introduce tu nombre, apellidos y un correo electrónico válido.",
    consentError: "Marca la casilla de consentimiento antes de suscribirte.",
    noConsentSuccess: "No hay problema. No te hemos suscrito.",
    emailError: "Introduce un correo electrónico válido.",
    success: "Gracias por suscribirte. Te hemos añadido a la lista del boletín.",
    shortSuccess: "Gracias por suscribirte.",
    saving: "Guardando...",
    subscribing: "Suscribiendo...",
    subscribe: "Suscribirme",
    footerHeading: "Mantente saludable con nuestros consejos de nutrición",
    footerIntro: "Suscríbete para recibir correos mensuales con consejos de nutrición, recetas deliciosas, artículos del blog y ofertas especiales. No te preocupes, respetamos tu bandeja de entrada: solo recibirás uno o dos correos al mes y puedes darte de baja cuando quieras."
  },
  blog: {
    eyebrow: "Blog de Nutrition by Iballa",
    heading: "Orientación nutricional basada en la evidencia",
    intro: "Artículos prácticos y cercanos para ayudarte a comprender tu salud y crear hábitos nutricionales sostenibles.",
    latest: "Último artículo",
    allPosts: "Todos los artículos",
    readMore: "Leer más",
    back: "Volver al blog",
    references: "Referencias",
    previous: "Artículo anterior",
    next: "Artículo siguiente",
    notFound: "Artículo no encontrado",
    notFoundText: "El artículo que buscas no está disponible."
  },
  assessment: {
    title: "Evaluación nutricional",
    intro: "Obtén una visión general de tus hábitos nutricionales diarios y algunas ideas sencillas para apoyar tus objetivos.",
    beforeTitle: "Antes de empezar",
    beforeIntro: "Añade tus datos para comenzar tu resumen nutricional personalizado.",
    firstName: "Nombre",
    lastName: "Apellidos",
    email: "Correo electrónico",
    consentHeading: "Preferencia de suscripción por correo electrónico",
    consentTitle: "Mantente saludable con nuestros consejos de nutrición",
    consentDescription: "Suscríbete para recibir correos mensuales con consejos de nutrición, recetas deliciosas y artículos del blog. No te preocupes, respetamos tu bandeja de entrada: solo recibirás uno o dos correos al mes y puedes darte de baja cuando quieras.",
    consent: "Mantente saludable con nuestros consejos de nutrición. Suscríbete para recibir correos mensuales con consejos de nutrición, recetas deliciosas y artículos del blog. No te preocupes, respetamos tu bandeja de entrada: solo recibirás uno o dos correos al mes y puedes darte de baja cuando quieras.",
    noConsent: "No, no quiero recibir estos correos.",
    signupButton: "Sí, quiero recibir estas comunicaciones",
    detailsError: "Introduce tu nombre, apellidos y un correo electrónico válido.",
    saving: "Guardando...",
    start: "Empezar la evaluación",
    complete: "Evaluación completada",
    step: (current, total) => `Paso ${current} de ${total}`,
    contactDetails: "Datos de contacto",
    disclaimer: "Esta herramienta ofrece únicamente información educativa general. No diagnostica ni sustituye el asesoramiento médico o dietético personalizado.",
    percentComplete: (value) => `${value}% completado`,
    back: "Atrás",
    viewResults: "Ver resultados",
    next: "Siguiente",
    summary: "Tu resumen general",
    outOf: "de 100",
    positiveFocus: "Lo que ya va bien",
    improvementFocus: "Áreas en las que centrarte ahora",
    noPositiveFocus: "Tus respuestas ofrecen un buen punto de partida. A medida que ganes constancia, será más fácil destacar áreas positivas concretas.",
    recommendations: "Recomendaciones prácticas",
    tailoredHeading: "¿Buscas una orientación nutricional personalizada?",
    tailoredText: "Aunque esta evaluación ofrece información nutricional general, una consulta permite recibir recomendaciones adaptadas a tus objetivos, estilo de vida e historial de salud.",
    book: "RESERVAR UNA CONSULTA",
    backAnswers: "Volver a las respuestas",
    restart: "Reiniciar la evaluación"
  },
  admin: {
    eyebrow: "Administración",
    heading: "Suscriptores del boletín",
    intro: "Revisa el consentimiento, el origen del alta y el estado de la suscripción.",
    notConfigured: "Supabase no está configurado",
    notConfiguredText: "Añade REACT_APP_SUPABASE_URL y REACT_APP_SUPABASE_PUBLISHABLE_KEY a .env.local para habilitar el acceso de administración.",
    checking: "Comprobando la sesión...",
    signIn: "Acceso de administración",
    signInHelp: "Utiliza tu cuenta de administración de Supabase Auth.",
    email: "Correo electrónico",
    password: "Contraseña",
    signInButton: "Iniciar sesión",
    accessRequired: "Se requiere acceso de administración",
    accessText: "Has iniciado sesión, pero esta cuenta no figura en la tabla admin_users.",
    signOut: "Cerrar sesión",
    signedIn: "Sesión iniciada como administrador",
    columns: ["Nombre", "Correo electrónico", "Origen", "Consentimiento", "Fecha de alta", "Estado de la suscripción", "Sincronización con MailerLite", "Acción"],
    loading: "Cargando suscriptores...",
    empty: "Todavía no hay suscriptores.",
    consented: "Consentimiento otorgado",
    noConsent: "Sin consentimiento",
    unsubscribed: "Dado de baja",
    subscribed: "Suscrito",
    markSubscribed: "Marcar como suscrito",
    markUnsubscribed: "Marcar como dado de baja",
    sources: { blog: "Blog", homepage: "Página principal", assessment: "Evaluación" },
    providerStatuses: {
      synced: "Sincronizado",
      pending: "Pendiente",
      failed: "Fallido",
      skipped: "Omitido",
      not_configured: "No configurado"
    }
  }
};

export function getUiContent(language) {
  return language?.startsWith("es") ? spanish : english;
}
